import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { CampaniasGlobalService } from '../../../services/global-campanias.service';
import {
    ActivaSelected,
    CASelectedViewModel,
    FilterSearchingSolicitudCam,
    PeriodoDatosCaCamViewModel,
    SolicitudCamItemResultsViewModel,
} from '../buscador-solicitud-cam.types';
import { EnumSiNoTodos, FilterSearchingBaseViewModel, Tc } from 'src/app/components/core/_infrastructure/types/common';
import { catchError, of, tap } from 'rxjs';
import { GlobalService } from 'src/app/components/core/_infrastructure/classes/services/global.service';
import { equalObjects } from '../../../types/solicitudcam-datosbasicos.types';
import { ConfirmationService } from 'primeng/api';
import { SolicitudCamService } from '../../../solicitudes/datosbasicos/solicitud-cam.service';
import { BuscadorSolicitudCamService } from '../buscador-solicitud-cam.service';
import { EnumCodigosTwTcAcciones } from 'src/app/components/_importacion/solicitudes/types/enum';
import { NavMenuService } from 'src/app/components/core/components/navmenu/navmenu.service';

@Component({
    selector: 'app-buscador-solicitudcam-wrapper',
    templateUrl: './buscador-solicitudcam-wrapper.component.html',
    styleUrls: ['./buscador-solicitudcam-wrapper.component.scss'],
})
export class BuscadorSolicitudcamWrapperComponent extends ComponentBase implements OnInit {
    spinnerExport = false;
    searching = false;
    result: SolicitudCamItemResultsViewModel | null;
    payload?: FilterSearchingSolicitudCam;

    activa = EnumSiNoTodos.TODOS;
    campanias: Tc[] = [];
    periodos: Tc[] = [];
    tiposSolicitud: Tc[] = [];
    CAs: PeriodoDatosCaCamViewModel[] = [];
    estadosSolicitud: Tc[] = [];
    EAs: Tc[] = [];

    constructor(
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private globalCampaniasService: CampaniasGlobalService,
        private globalService: GlobalService,
        private buscadorSolicitudCamService: BuscadorSolicitudCamService,
        private navMenuService: NavMenuService,
        private router: Router,
        private confirmationService: ConfirmationService,
        private solicitudCamService: SolicitudCamService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.recoverLastSearch();
        this.loadListsForFilters();
    }

    private loadListsForFilters(): void {
        this.getTiposSolicitudCam();
        this.getEstadosSolicitudCam();
        const activaSelected: ActivaSelected = { Activa: this.activa, cleanDependent: false };
        this.onActivaSelected(activaSelected);
    }

    private getTiposSolicitudCam(): void {
        this.globalService.getTipoSolicitudCam().subscribe(res => {
            this.tiposSolicitud = res;
        });
    }

    private getEstadosSolicitudCam(): void {
        this.globalCampaniasService.getEstadosSolicitudCam().subscribe(res => {
            this.estadosSolicitud = res;
        });
    }

    /**
     * We try to get back the previous search done by the user.
     */
    private recoverLastSearch() {
        this.payload = this.buscadorSolicitudCamService.getLastSearch();
    }

    private getEveryCA(): void {
        this.globalService.getComunidadesAutonomas().subscribe((comunidades: Tc[]) => {
            let filteredCAs = comunidades;
            if (this.isCA) {
                filteredCAs = comunidades.filter(val => val.Id === this.userData?.idCA);
            }

            this.CAs = filteredCAs?.map(val => {
                const ca = new PeriodoDatosCaCamViewModel();
                ca.IdCa = val.Id;
                ca.ComunidadAutonoma = val.Descripcion;
                return ca;
            });
        });
    }

    onActivaSelected(event$: ActivaSelected): void {
        this.activa = event$.Activa;
        if (event$.cleanDependent) {
            this.cleanDependentOnActiva();
        }
        this.loadDependentOnActiva();
    }

    private loadDependentOnActiva() {
        this.getCampanias();
        this.onCampaniaSelected(this.payload?.IdCampania);
        this.onPeriodoSelected(this.payload?.IdPeriodo);
        const caSelected = new CASelectedViewModel();
        caSelected.idCA = this.payload?.IdCA;
        caSelected.idPeriodo = this.payload?.IdPeriodo;
        this.onCASelected(caSelected);
    }

    private getCampanias(): void {
        this.campanias = [];
        this.globalCampaniasService.getCampaniasByProfile(this.activa).subscribe(res => {
            this.campanias = [...res];
        });
    }

    onCampaniaSelected(idCampania?: number): void {
        this.getPeriodos(idCampania);
    }

    private getPeriodos(idCampania?: number): void {
        if (!idCampania) {
            this.periodos = [];
            return;
        }
        this.periodos = [];
        this.globalCampaniasService.getPeriodosByCampania(idCampania, this.activa).subscribe(res => {
            this.periodos = [...res];
        });
    }

    onPeriodoSelected(idPeriodo?: number): void {
        this.getCAs(idPeriodo);
    }

    private getCAs(idPeriodo?: number): void {
        if (!idPeriodo) {
            this.getEveryCA();
            return;
        }
        this.CAs = [];
        this.globalCampaniasService.getCAsByPeriodo(idPeriodo).subscribe(res => {
            this.CAs = [...res];
            // Disparamos CaSelected cuando el usuario es CA, porque no se "pinta" el desplegable de CAs en pantalla.
            // de otra forma, nunca se cargarían en pantalla los dependendientes de la CA.
            if (this.isCA && this.CAs.length > 0) {
                const caSelectedViewModel = new CASelectedViewModel();
                caSelectedViewModel.idCA = this.CAs.at(0)?.IdCa; // Si el usuario es CA, solo tendrá 1 CA en el desplegable.
                caSelectedViewModel.idPeriodo = idPeriodo;
                this.onCASelected(caSelectedViewModel);
            }
        });
    }

    onCASelected(param$: CASelectedViewModel): void {
        this.EAs = [];
        if (!param$.idPeriodo || !param$.idCA) {
            return;
        }
        this.globalCampaniasService.getEAsByCA(param$).subscribe(res => {
            this.EAs = res;
        });
    }

    /**
     * Respond to the action of searching on "buscador-solicitud-cam-filter".
     * It will send the filter to the backend and set the response.
     * If the search comes from the "filter" component, the fields related to the pagination will be reset.
     * In the search comes from the "list-paginator" component case the search params remain the same.
     * @param payload FilterSearchingSolicitudCam
     * @return void
     */
    onSearch(payload: FilterSearchingSolicitudCam): void {
        this.navMenuService.clearMenuServiceForSolicitudCam();
        if (!equalObjects(this.payload, payload)) {
            // As soon as the user changes the "filter", the previous payload pagination values have no sense
            // When recovering the request params from the last result, the pagination params won't be reset.
            payload = this.clearPaginationFilter(payload);
        }

        this.payload = { ...payload } as FilterSearchingSolicitudCam; // To keep a copy to be used in the lazy search (paginator)
        if (!payload) {
            return;
        }
        if (this.payload.Activa === null) {
            this.payload.Activa = EnumSiNoTodos.TODOS;
        }
        // No seteamos a 0 el valor del campo SoloDevueltas, porque realmente no se envía. El control en pantalla lo que hace es seleccionar en el desplegable de estados el valor de "Devueltas"

        this.payload.IdUsuario = this.userData.idUsuario;
        this.searching = true;
        this.result = null;

        this.buscadorSolicitudCamService
            .getSolicitudesCam(this.payload)
            .pipe(
                tap(results => {
                    this.result = results as SolicitudCamItemResultsViewModel;
                    this.searching = true;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of([]);
                }),
            )
            .subscribe();
    }

    /**
     * We don't clear the whole filter but only the fields related to the pagination.
     */
    private clearPaginationFilter(payload: FilterSearchingSolicitudCam): FilterSearchingSolicitudCam {
        if (!payload) {
            return payload;
        }
        payload.PageNumber = 0;
        payload.Asc = 0;
        payload.OrderBy = '';
        return payload;
    }

    /**
     * It will be invoked when using the paginator
     * @param lazyLoadParams FilterSearchingBaseViewModel
     * @return void
     */
    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        this.payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingSolicitudCam;
        this.onSearch(this.payload);
    }

    /**
     * Invoked when the user wants to clear the form
     * @return void
     */
    onReset(): void {
        this.searching = false;
        this.result = null;
        this.activa = EnumSiNoTodos.TODOS;
        const activaSelected: ActivaSelected = { Activa: this.activa, cleanDependent: false };
        this.onActivaSelected(activaSelected);
        this.buscadorSolicitudCamService.resetFilter();
        this.navMenuService.clearMenuServiceForSolicitudCam();
    }

    /**
     * Se crea éste método en vez de usar recoverLastSearch, porque éste tiene en cuenta si ha cambiado la consulta o si entramos de nuevas en el componente.
     * En éste método se fuerza a cargar de nuevo la consulta.
     */
    private reloadSearch(): void {
        this.onSearch(this.payload!);
    }

    private cleanDependentOnActiva(): void {
        if (this.payload) {
            this.payload.IdCampania = 0;
        }

        this.cleanDependentOnCampania();
    }

    private cleanDependentOnCampania(): void {
        if (this.payload) {
            this.payload.IdPeriodo = 0;
            this.payload.IdCA = 0;
            this.payload.IdEntidadAuditora = 0;
        }
    }

    /**
     * Redirigimos al formulario de creación de una nueva solicitud
     * @return void
     */
    onAdd(): void {
        this.router.navigate(['/campanias/solicitud/datosbasicos/create']);
    }

    /**
     * Redirigimos al formulario de edición de la solicitud.
     * Cuando el parámetro sea null, el backend captura el error y se muestra en pantalla.
     * @param itemId number|null
     * @return void
     */
    onEdit(itemId: number | null): void {
        this.router.navigate(['/campanias/solicitud/datosbasicos/detail', itemId]);
    }

    /**
     * Redirigimos al formulario de edición de la solicitud, pero en modo consulta
     * Cuando el parámetro sea null, el backend captura el error y se muestra en pantalla.
     * @param itemId number|null
     * @return void
     */
    onView(itemId: number | null): void {
        this.router.navigate(['/campanias/solicitud/datosbasicos/detail', itemId]);
    }

    /**
     * Invoked when the user wants to export the result to excel
     * @return void
     */
    onExportExcel(): void {
        let model: FilterSearchingSolicitudCam = new FilterSearchingSolicitudCam();
        Object.assign(model, this.payload);
        this.spinnerExport = true;
        this.buscadorSolicitudCamService.export(model).subscribe(res => {
            this.spinnerExport = false;
            this.OpenDownloadedFile(res);
        });
    }

    onDelete($event: { idSolicitudCam: number; idTipoSolicitudCam: number }): void {
        this.confirmationService.confirm({
            message: 'Si elimina la Solicitud de Campaña, se desvincularían sus Recintos y se borrarían los Documentos asociados, ¿desea continuar?',
            accept: () => {
                this.delete($event?.idSolicitudCam, $event.idTipoSolicitudCam);
            },
        });
    }

    private delete(idSolicitudCam: number, idTipoSolicitudCam: number): void {
        this.solicitudCamService
            .deleteSolicitudCam(idSolicitudCam, idTipoSolicitudCam)
            .pipe(
                tap(() => {
                    this.addSuccessMessage('Borrado realizado con éxito');
                    this.reloadSearch();
                }),
                catchError(error => {
                    this.catchServerError(error);
                    return of(null);
                }),
            )
            .subscribe();
    }

    /**
     * To check whether there are results to export
     * @returns boolean
     */
    get exportIsAvailable(): boolean {
        const hasAccess = this.loggedInUser?.getAction(EnumCodigosTwTcAcciones.EXCEL_SOLES_CAM).Editable || false;
        return hasAccess && this.result?.ResultList ? this.result?.ResultList?.length > 0 : false;
    }

    get allowNuevaSolicitud(): boolean {
        return this.loggedInUser?.getAction(EnumCodigosTwTcAcciones.NEW_SOL_CAM).Editable || false;
    }
}
